(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-marketplace-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-ks-cta]');
    if (!link) return;
    var location = link.getAttribute('data-ks-cta');
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'journey_planner_click', { cta_location: location });
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'journey_planner_click', cta_location: location });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
